import { render, staticRenderFns } from "./information-videos.vue?vue&type=template&id=bf5872ba&scoped=true"
import script from "./information-videos.vue?vue&type=script&lang=js"
export * from "./information-videos.vue?vue&type=script&lang=js"
import style0 from "./information-videos.vue?vue&type=style&index=0&id=bf5872ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5872ba",
  null
  
)

export default component.exports